import ServingStepper from './ServingStepper';
import RecipeFacts from './RecipeFacts';

export default function RecipeHero({ heroImage, heroAlt, servings = {}, facts = {} }) {
  const factItems = [
    { label: 'Prep time', value: facts.prepTime },
    { label: 'Set time', value: facts.setTime },
    { label: 'Amount', value: facts.amount }
  ].filter((item) => item.value);

  return (
    <section className="py-12 px-6">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[1.1fr_1fr] gap-10 items-start">
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="aspect-[4/3] overflow-hidden">
            <img
              src={heroImage}
              alt={heroAlt}
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-gray-900 mb-6">
            Basic Recipe Preparation &amp; Variations
          </h2>
          <div className="grid grid-cols-2 gap-6 items-center mb-8">
            <div>
              <p className="text-sm font-semibold text-gray-700 uppercase tracking-wide">
                Serving
              </p>
              <div className="mt-2">
                <ServingStepper
                  min={servings.min}
                  max={servings.max}
                  step={servings.step}
                  value={servings.value}
                />
              </div>
            </div>
            <div className="hidden sm:block" />
          </div>
          <RecipeFacts items={factItems} />
        </div>
      </div>
    </section>
  );
}
